const GOOGLE_ADS_ID = "AW-453281587";

const CONVERSIONS = {
  onlinePaid: `${GOOGLE_ADS_ID}/gHiOCPDZx_EcELOOktgB`,
  phoneCall: `${GOOGLE_ADS_ID}/UDN7CPaD6_EcELOOktgB`,
  whatsapp: `${GOOGLE_ADS_ID}/yv54CKi67PEcELOOktgB`,
  emailClick: `${GOOGLE_ADS_ID}/zYT_CLiT9vEcELOOktgB`,
};

const CONSENT_STORAGE_KEY = "cabcity_cookie_consent";
const FIRED_STORAGE_PREFIX = "cabcity_google_ads_fired_";

function hasAdvertisingConsent() {
  if (typeof window === "undefined") return false;

  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return false;

    const consent = JSON.parse(raw);
    return consent?.advertising === true;
  } catch {
    return false;
  }
}

function alreadyFired(key) {
  if (typeof window === "undefined") return false;

  try {
    return window.sessionStorage.getItem(
      `${FIRED_STORAGE_PREFIX}${key}`
    ) === "1";
  } catch {
    return false;
  }
}

function markFired(key) {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.setItem(
      `${FIRED_STORAGE_PREFIX}${key}`,
      "1"
    );
  } catch {
    // Ignore storage failures; the conversion can still be sent.
  }
}

export function trackGoogleAdsConversion({
  type,
  value,
  transactionId,
}) {
  const sendTo = CONVERSIONS[type];

  if (!sendTo || typeof window === "undefined") return false;
  if (!hasAdvertisingConsent()) return false;
  if (typeof window.gtag !== "function") return false;

  const dedupeKey = transactionId
    ? `${type}_${transactionId}`
    : `${type}_${Date.now()}_${Math.random().toString(36).slice(2)}`;

  if (transactionId && alreadyFired(dedupeKey)) return false;

  const numericValue = Number(value);

  window.gtag("event", "conversion", {
    send_to: sendTo,
    value: Number.isFinite(numericValue) ? numericValue : 0,
    currency: "EUR",
    ...(transactionId
      ? { transaction_id: String(transactionId) }
      : {}),
  });

  markFired(dedupeKey);
  return true;
}
